module.exports = __webpack_public_path__ + "media/toolkits/COVID-mobile-ecosystem-a100e9ef.png";